import React from 'react';

import { SpecCourseLessonViewSectionDescription } from 'common.components/spec-course-lesson-view/__section-description/spec-course-lesson-view__section-description';
import { SpecCourseLessonViewSectionTitle } from 'common.components/spec-course-lesson-view/__section-title/spec-course-lesson-view__section-title';
import { SpecCourseLessonViewSection } from 'common.components/spec-course-lesson-view/__section/spec-course-lesson-view__section';

import './spec-course-lesson-view__rules.scss';

interface Props {
    specialRules?: React.ReactNode | Array<React.ReactNode>;
    text?: string;
    shouldShowTitle?: boolean;
}

export const SpecCourseLessonViewRules = ({ specialRules, text, shouldShowTitle = true }: Props) => {
    return (
        <SpecCourseLessonViewSection>
            {shouldShowTitle && <SpecCourseLessonViewSectionTitle id={'specCourse.Rules.Title'} />}
            {specialRules}
            <SpecCourseLessonViewSectionDescription mix="spec-course-lesson-view__rules-info">
                {text}
            </SpecCourseLessonViewSectionDescription>
        </SpecCourseLessonViewSection>
    );
};
